/* THE FIT SOCIETY — v37 : ajout au panier robuste, jamais bloqué, erreur visible.

   Trois problèmes traités :

   1. theme.js contient une sortie SILENCIEUSE dans son handler de soumission :
          if (!addButton || addButton.disabled || !idInput?.value) return;
      Si l'identifiant de variante n'a pas été résolu, le clic ne fait RIEN :
      pas de message, pas de spinner. C'est exactement « Précommander ne marche pas ».

   2. Le bouton peut arriver `disabled` (variante marquée épuisée) et theme.js le
      re-désactive à chaque changement de variante. En période de drop, on doit
      TOUJOURS pouvoir commander : un observateur retire l'attribut `disabled`
      dès qu'il réapparaît, et remet le bon libellé.

   3. En cas de refus de Shopify, on affichait un échec muet. Ici on affiche le
      message EXACT renvoyé par Shopify + le code HTTP + l'id de variante.

   Ce script prend la main sur le clic en phase de CAPTURE, donc avant theme.js.
   Compatible desktop et mobile, bouton principal et barre collante. */
(function () {

  function init(root) {
    var errorBox = root.querySelector('[data-product-error]');
    var jsonNode = root.querySelector('[data-product-json]');
    var data = null;
    try { data = JSON.parse(jsonNode.textContent); } catch (e) { return; }
    var variants = (data && data.variants) || [];
    if (!variants.length) return;

    var preorderLabel = root.getAttribute('data-preorder-label') || '';
    var defaultLabel = preorderLabel || 'Ajouter au panier';

    function show(msg) {
      if (errorBox) {
        errorBox.textContent = msg;
        errorBox.hidden = false;
        try { errorBox.scrollIntoView({ block: 'center' }); } catch (e) {}
      } else {
        window.alert(msg);
      }
    }

    /* ── 2. On ne laisse plus rien désactiver les boutons de commande ── */
    function unlock(btn) {
      if (!btn) return;
      if (btn.disabled || btn.hasAttribute('disabled')) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        var txt = (btn.textContent || '').trim().toLowerCase();
        if (txt.indexOf('puis') > -1 || txt.indexOf('sold') > -1 || txt === '') {
          btn.textContent = defaultLabel;
        }
      }
    }

    function watch(btn) {
      if (!btn) return;
      unlock(btn);
      try {
        new MutationObserver(function () { unlock(btn); })
          .observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      } catch (e) {}
    }

    /* ── 1. Résolution de la variante, sans dépendre du champ caché ── */
    function resolveVariant() {
      var groups = root.querySelectorAll('[data-option-index]');
      if (!groups.length) return variants[0];
      var chosen = [];
      for (var i = 0; i < groups.length; i++) {
        var checked = groups[i].querySelector('input:checked');
        if (!checked) return null;           // une option manque encore
        chosen.push(checked.value);
      }
      for (var v = 0; v < variants.length; v++) {
        var opts = variants[v].options || [];
        var ok = true;
        for (var o = 0; o < chosen.length; o++) {
          if (opts[o] !== chosen[o]) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
      return null;
    }

    function onClick(event) {
      var groups = root.querySelectorAll('[data-option-index]');
      var variant = resolveVariant();

      if (!variant) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (groups.length) {
          show('Choisis ta taille pour continuer.');
          try { groups[groups.length - 1].scrollIntoView({ block: 'center' }); } catch (e) {}
        } else {
          show('Cette pièce est momentanément indisponible.');
        }
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var btn = event.currentTarget;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      if (errorBox) errorBox.hidden = true;

      var body = new FormData();
      body.append('id', String(variant.id));
      var qty = root.querySelector('select[name="quantity"], input[name="quantity"]');
      body.append('quantity', qty ? qty.value : '1');
      var props = root.querySelectorAll('input[name^="properties["]');
      for (var p = 0; p < props.length; p++) body.append(props[p].name, props[p].value);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (r) {
          return r.json().then(function (payload) {
            return { ok: r.ok, status: r.status, payload: payload || {} };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var m = res.payload.description || res.payload.message || 'Refus sans message';
            throw new Error(m + '  [HTTP ' + res.status + ' · variante ' + variant.id + ']');
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          show('Shopify a refusé l’ajout : ' + err.message);
          if (btn) { btn.disabled = false; btn.textContent = label; unlock(btn); }
        });
    }

    var main = root.querySelector('[data-add-to-cart]');
    if (main) { watch(main); main.addEventListener('click', onClick, true); }

    var sticky = document.querySelector('[data-sticky-submit]');
    if (sticky) { watch(sticky); sticky.addEventListener('click', onClick, true); }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-product-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
